<template>
    <zen-one
        :showuserinfo="false"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
        :crumbs="crumbs"
    >
        <z-page title="Perumahan">
            <w-flex class="mt3">
                <div class="xs4">
                    <z-lookup
                        label="Daerah"
                        name="daerah"
                        :url="service_utiliti + 'lookup/daerah'"
                        placeholder="Sila Pilih Daerah"
                        :sort="false"
                        :cache="false"
                        v-model="cari.lkp_daerah_id"
                    />
                </div>
                <div class="xs4">
                    <z-lookup
                        label="Daerah"
                        name="daerah"
                        :url="service_utiliti + 'lookup/lkp_perumahan_jenis'"
                        placeholder="Sila Pilih Jenis"
                        :sort="false"
                        :cache="false"
                        v-model="cari.lkp_daerah_id"
                    />
                </div>
                <div class="xs4">
                    <w-input
                        label="Kod"
                        name="kod"
                        placeholder="Sila Masukkan Kod"
                        :sort="false"
                        :cache="false"
                        v-model="cari.kod"
                    />
                </div>
            </w-flex>

            <w-flex class="mt3">
                <div class="xs4">
                    <w-input
                        label="Keterangan"
                        name="keterangan"
                        placeholder="Sila Masukkan Keterangan"
                        :sort="false"
                        :cache="false"
                        v-model="cari.Keterangan"
                    />
                </div>
                <div class="xs4">
                    <w-input
                        label="Skim Perumahan"
                        name="skim_perumahan"
                        placeholder="Sila Masukkan Skim Perumahan"
                        :sort="false"
                        :cache="false"
                        v-model="cari.skim_perumahan"
                    />
                </div>
            </w-flex>

            <div class="mt2 text-right">
                <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                    <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1" @click="search()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
            </div>
            <br>

            <w-dialog
                v-model="modal.show"
                :fullscreen="modal.fullscreen"
                :width="modal.width"
                :persistent="modal.persistent"
                :persistent-no-animation="modal.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title> Paparan Perumahan </template>
                <template #default>
                    <w-form
                        ref="form"
                        v-model="modal.valid"
                        @validate="send"
                        @success="success"
                    >
                        <w-flex class="mt3">
                            
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Kod :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ form.kod }}
                                </div>
                            </div>
                           
                        </w-flex>

                        <w-flex class="mt3">
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Keterangan :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ form.keterangan }}
                                </div>
                            </div>
                        </w-flex>
                         <w-flex class="mt3">
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Keterangan :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ form.skim_perumahan }}
                                </div>
                            </div>
                        </w-flex>
                        <w-flex class="mt3">
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Jenis :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ form.jenis_perumahan_keterangan }}
                                </div>
                            </div>
                        </w-flex>
                        <w-flex class="mt3">
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Daerah :</h5>
                                <div class="fw-normal my1 fs-1">
                                    {{ form.daerah_keterangan }}
                                </div>
                            </div>
                        </w-flex>
                         <w-flex class="mt3">
                            <div class="xs4">
                                <h5 class="fw-semibold m0">Status :</h5>
                                <div class="fw-normal my1 fs-1">
                                    <template v-if="form.status= 1">
                                        Aktif
                                    </template>
                                    <template v-else>
                                        Tidak Aktif
                                    </template>
                                </div>
                            </div>
                        </w-flex>
                       <!--  <w-tabs
                            :items="tabs"
                            :no-slider="false"
                            active-class="primary"
                        > -->
                            <!-- <template #item-content.1>
                                <table class="w-table">
                                    <thead>
                                        <tr>
                                            <th
                                                class="w-table__header w-table__header--sortable text-left"
                                            >
                                                No
                                            </th>
                                            <th
                                                class="w-table__header w-table__header--sortable text-left"
                                            >
                                                Tindakan
                                            </th>
                                            <th
                                                class="w-table__header w-table__header--sortable text-left"
                                            >
                                                Pengguna
                                            </th>
                                            <th
                                                class="w-table__header w-table__header--sortable text-left"
                                            >
                                                Tarikh
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="(
                                                dt, index
                                            ) in form.jejak_audit"
                                        >
                                            <td class="w-table__cell text-left">
                                                {{ index + 1 }}
                                            </td>
                                            <td class="w-table__cell text-left">
                                                {{
                                                    dt.tindakan_bank_keterangan
                                                }}
                                            </td>
                                            <td class="w-table__cell text-left">
                                                {{ dt.user_nama }}
                                            </td>
                                            <td class="w-table__cell text-left">
                                                {{ dt.tarikh }}
                                            </td>
                                        </tr>
                                        <tr v-if="form.jejak_audit.length == 0">
                                            <td
                                                class="w-table__cell text-left"
                                                colspan="5"
                                            ></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </template> -->
                        <!-- </w-tabs> -->
                    </w-form>
                </template>
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="modal.show = false"
                        >Tutup</w-button
                    >
                </template>
            </w-dialog>
            <w-dialog
                v-model="dialog.show"
                :fullscreen="dialog.fullscreen"
                :width="dialog.width"
                :persistent="dialog.persistent"
                :persistent-no-animation="dialog.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <template v-if="form.id"> Kemaskini Lkp Perumahan </template>
                    <template v-else> Tambah Perumahan </template>
                </template>
                <template #default>
                    <w-form
                        ref="form"
                        v-model="dialog.valid"
                        @validate="submit"
                        @success="success"
                    >
                        <template></template>

                        <w-flex justify-space-between class="mb4">
                            <z-lookup
                                label="Jenis*"
                                name="jenis"
                                :url="service_utiliti + 'lookup/lkp_perumahan_jenis'"
                                :sort="false"
                                :cache="false"
                                v-model="form.lkp_perumahan_jenis_id"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                         <w-flex justify-space-between class="mb4">
                            <z-lookup
                                label="Daerah*"
                                name="daerah"
                                :url="service_utiliti + 'lookup/daerah'"
                                :sort="false"
                                :cache="false"
                                v-model="form.lkp_daerah_id"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                label="Kod*"
                                name="kod"
                                v-model="form.kod"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                label="Keterangan*"
                                name="keterangan"
                                v-model="form.keterangan"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                label="Skim Perumahan*"
                                name="skim_perumahan"
                                v-model="form.skim_perumahan"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                    </w-form>

                    <template v-if="form.id">
                         <w-flex justify-space-between class="mb4">
                            <z-lookup
                                label="Status*"
                                name="status"
                                :options="status"
                                :sort="false"
                                :cache="false"
                                v-model="form.status"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                    </template>
                </template>
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialog.show = false"
                        >Tutup</w-button
                    >
                    <w-button
                        class="ml1"
                        :loading="dialog.loading"
                        :disabled="dialog.valid === false"
                        @click="$refs.form.validate()"
                        >{{ form.saveButton }}</w-button
                    >
                </template>
            </w-dialog>

            <z-table
                ref="tbluser"
                title="Senarai Perumahan"
                :headers="table.headers"
                :items="table.items"
                :meta="table.meta"
                class=""
            >
                <template #button>
                    <!-- <template v-if="$zutil.can('Bank Tambah')"> -->
                        <w-button
                            dark
                            class="indigo-dark2--bg ml1"
                            @click="newrecord()"
                        >
                            <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                        </w-button>
                    <!-- </template> -->
                </template>
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on" tile @click="show(item)">
                                    fal fa-eye
                                </w-icon>
                            </template>
                            Papar
                        </w-tooltip>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <!-- <template v-if="$zutil.can('Bank Kemaskini')"> -->
                                    <w-icon v-on="on" tile @click="edit(item)">
                                        fal fa-pencil
                                    </w-icon>
                                <!-- </template> -->
                            </template>
                            Kemaskini
                        </w-tooltip>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on" tile @click="destroy(item)">
                                    fal fa-trash
                                </w-icon>
                            </template>
                            Padam
                        </w-tooltip>
                    </w-flex>
                </template>
            </z-table>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {
        // ZenOne
    },
    props: {
        items: [Array, Object],
    },
    data() {
        return {
            resourceurl: this.service_utiliti + "lkp_perumahan",
            reload: true,
            status: [
                {
                    value: 1,
                    label: "AKTIF",
                },
                {
                    value: 0,
                    label: "TIDAK AKTIF",
                },
            ],

            // status1: [
            //     {
            //         value: 1,
            //         label: "TERIMAAN",
            //     },
            // ],
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Utiliti", route: "/utiliti" },
                { label: "Perumahan ", route: "/utiliti/perumahan" },
            ],

            tabs: [{ title: "Jejak Audit", content: "" }],
            cari: {
                lkp_daerah_id: "",
                lkp_perumahan_jenis_id: "",
                kod: "",
                keterangan: "",
                skim_perumahan: "",
            },
        };
    },
    methods: {
        search() {
            this.$inertia.visit(
                window.route("utiliti.lkp_perumahan.index") +
                    "?lkp_daerah_id=" +
                    this.cari.lkp_daerah_id +
                    "&lkp_perumahan_jenis_id=" +
                    this.cari.lkp_perumahan_jenis_id +
                    "&kod=" +
                    this.cari.kod +
                    "&keterangan=" +
                    this.cari.keterangan+
                    "&skim_perumahan=" +
                    this.cari.skim_perumahan,
                { preserveScroll: true }
            );
        },
        reset() {
            this.cari = {
                lkp_daerah_id: "",
                lkp_perumahan_jenis_id: "",
                kod: "",
                keterangan: "",
                skim_perumahan: "",
            };
            this.search();
        },

        show(idx) {
            this.form = idx;
            this.form.saveButton = "Kemaskini";
            this.modal.show = true;
        },
    },
    watch: {},
    mounted() {
        this.dialog.width = 500;
        this.cari = location.search
            .slice(1)
            .split("&")
            .map((p) => p.split("="))
            .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
        if (this.cari.lkp_daerah_id == "undefined") {
            this.cari.lkp_daerah_id = "";
        }
        if (this.cari.lkp_perumahan_jenis_id == "undefined") {
            this.cari.lkp_perumahan_jenis_id = "";
        }
        if (this.cari.kod == "undefined") {
            this.cari.kod = "";
        }
        if (this.cari.keterangan == "undefined") {
            this.cari.keterangan = "";
        }
        if (this.cari.skim_perumahan == "undefined") {
            this.cari.skim_perumahan = "";
        }
    },
};
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
